// @ts-strict

import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-columns-btn',
  templateUrl: './manage-columns-btn.component.html',
  styleUrls: ['./manage-columns-btn.component.scss']
})
export class ManageColumnsBtnComponent {
  @Input() detailsLayout: boolean = false;
  @Input() tableTitle: string = '';

  public menuVisible = false;

  constructor() {}

  public toggleMenuVisible(): void {
    this.menuVisible = !this.menuVisible;
  }

  public closeMenu(): void {
    this.menuVisible = false;
  }
}
